<ion-card class="item-community__container" [id]="community.id">
  <div
    *ngIf="
      community.type === type.Information ||
      community.type === type.Events ||
      community.type === type.IntegrationTrip ||
      community.type === type.GoodPracticesList ||
      community.type === type.Agenda
    "
    class="invitation-mobile-header"
  >
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col size-xs="2" size-sm="1">
          <div class="ion-text-center">
            <ion-avatar
              class="display-flex ion-justify-content-center ion-align-items-center"
            >
              <img
                class="item-community__avatar"
                *ngIf="community.companyCreated.logo"
                [src]="
                  community.companyCreated.logo.thumbnail
                    ? community.companyCreated.logo.thumbnail
                    : community.companyCreated.logo.filePath
                "
              />
            </ion-avatar>
          </div>
        </ion-col>
        <ion-col size-xs="8" size-md="9">
          <div class="item-community__subtitle">
            <span class="item-community__company-name">
              {{ community.companyCreated.name }}
            </span>
            <span 
              class="item-community__date"
              [ngClass]="{'item-community__date--nopublished': (isPublished(community.publishDate))}"
            >
              {{ community.publishDate | dateSti }}
            </span>
          </div>
        </ion-col>
        <ion-col class="ion-text-right" size="2">
          <div
            class="display-flex ion-justify-content-center ion-align-items-center"
          >
            <div
              class="options-button"
              size="small"
              (click)="presentPopover($event, community)"
              *ngIf="checkPermission()"
            >
              <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </div>
  <!-- board -->
  <div *ngIf="community.type === type.Board" class="invitation-mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col size-xs="2" size-sm="1">
          <div class="ion-text-center">
            <div class="avatar">
              <ion-avatar>
                <ion-label>
                  {{ getUserInitials(community.userCreated) }}
                </ion-label>
              </ion-avatar>
            </div>
          </div>
        </ion-col>
        <ion-col size-xs="8" size-md="9">
          <div class="item-community__subtitle">
            <span class="item-community__company-name">
              {{ community.userCreated.firstName }}
              {{ community.userCreated.lastName }}
            </span>
            <span class="item-community__date">
              {{ community.publishDate | dateSti }}
            </span>
          </div>
        </ion-col>
        <ion-col class="ion-text-center" size="2">
          <div
            class="display-flex ion-align-items-center ion-justify-content-center"
          >
            <div
              class="options-button"
              size="small"
              (click)="presentPopover($event, community)"
              *ngIf="checkPermission()"
            >
              <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </div>
  <!-- end board -->
  <div>
    <div class="content__header">
      <div class="title">
        <span (click)="navigateTo()">
          {{ community.title }}
        </span>
      </div>

      <div class="fab">
        <ion-chip
          [disabled]="true"
          *ngIf="(community.type === type.Events || community.type === type.Agenda) && community.localization"
          color="dark"
        >
          <ion-icon name="location-outline"></ion-icon>
          <ion-label> {{ community.localization }} </ion-label>
        </ion-chip>

        <ion-chip
          [disabled]="true"
          *ngIf="community.type === type.Events"
          color="dark"
        >
          <ion-icon name="time-outline"></ion-icon>
          <ion-label
            >{{ community.startTime | dateSti: 'onlyDate' }}
            <ng-container *ngIf="ifDatesAreDiffrent()">
              - {{ community.endTime | dateSti: 'onlyDate' }}
            </ng-container>
          </ion-label>
        </ion-chip>

        <ng-container *ngIf="community.type === type.Agenda">
          <ion-chip
            [disabled]="true"
            color="dark"
          >
            <ion-icon name="time-outline"></ion-icon>
            <ion-label>
              {{ community.startTime | dateSti: 'onlyHour' }} - {{ community.endTime | dateSti: 'onlyHour' }}
            </ion-label>
          </ion-chip>

          <ion-chip
            [disabled]="true"
            color="dark"
          >
            <ion-icon name="timer-outline"></ion-icon>
            <ion-label>
              {{ getDuration() }}
            </ion-label>
          </ion-chip>
        </ng-container>

      </div>
    </div>
    <div
      *ngIf="community.image"
      class="item-community__img"
      (click)="navigateTo()"
    >
      <div class="item-community__loader">
        <app-loading-sti></app-loading-sti>
      </div>
      <img
        [src]="community.image.filePath"
        (click)="onImagePreview($event, community.image.filePath)"
      />
    </div>
    <div class="item-community__description-container" (click)="onReroute()">
      <div
        #descriptionContainer
        *ngIf="community.description"
        class="item-community__description"
        [innerHTML]="description"
      ></div>
      <section *ngIf="community.description != null">
        <div
          *ngIf="
            !singleArticle && community.description?.length > maxDescriptionLength
          "
          class="item-community__more-button"
        >
          {{ 'MORE_RESULT' | translate }}
      </div>
      </section>
      
    </div>

    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col
          size-md="4"
          size="6"
          *ngFor="let image of community.additionalImages"
        >
          <img
            class="item-community__additional-image"
            [src]="image.filePath"
            (click)="onImagePreview($event, image.filePath)"
          />
        </ion-col>
      </ion-row>
    </ion-grid>

    <ng-container *ngIf="community.type !== type.Agenda">
      {{ community.commentsCount }}
      <app-comment
        [refreshCommentsOnInit]="refreshCommentsOnInit"
        [commentsCount]="community.commentsCount"
        [userPerformedBy]="community.idUserCreated"
        [id]="community.id"
        [tableName]="communityService.tableName"
        mode="comment"
        deletePermission="community.comments.delete"
      >
        <!-- (focusStateChanged)="keyboardOnScreen.emit($event)" -->
      </app-comment>
    </ng-container>
    
  </div>
</ion-card>
